import CurrentStudentsRow from './current-student-row'

export default CurrentStudentsRow
